import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import '../../stylings/AdmissionNotice.css';

export default function AdmissionNotice() {
  const notices = useSelector((state) => state.notices.notices);
  const admissionNotices = notices.filter((n) => n.noticeType === 'ADMISSION' || n.type === 'admission');

  const fallback = [
    { _id: 'a1', title: 'Admissions Open for Session 2025-26 – Classes Nursery to XII', date: '2025-04-01' },
    { _id: 'a2', title: 'Admission Form Available – Download Now', date: '2025-04-05' },
    { _id: 'a3', title: 'Last Date for Admission Registration: 30 June 2025', date: '2025-04-10' },
  ];

  const items = admissionNotices.length > 0 ? admissionNotices : fallback;

  return (
    <div className="notice-widget">
      <div className="notice-widget-header admission-header">
        <i className="fas fa-user-plus me-2"></i> Admission Notices
      </div>
      <div className="notice-widget-body">
        <ul className="notice-list">
          {items.slice(0, 6).map((n) => (
            <li key={n._id} className="notice-list-item">
              <Link to={`/notice/${n._id}`} className="notice-link">
                <span className="notice-dot admission-dot"></span>
                <div className="notice-text">
                  <p className="notice-title">{n.title}</p>
                  <span className="notice-date">
                    <i className="fas fa-calendar-check me-1"></i>
                    {moment(n.date || n.createdAt).format('DD MMM YYYY')}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="notice-widget-footer">
        <Link to="/noticeall">View All Notices →</Link>
      </div>
    </div>
  );
}
